<template>


    <div class="customdropzone" :class="{'table--files-wrapper': !overlay}"  v-show="show">
        <vue-dropzone ref="myVueDropzone" id="customdropzone" :class="{'customdropzone__area': overlay}" :options="dropzoneOptions"
                      @vdropzone-upload-progress="vProgress" @vdropzone-sending="vSendingFile"
                      @vdropzone-drag-enter="vDragStart"
                      @vdropzone-file-added="vFileAdded" @vdropzone-success="vSuccess" :useCustomSlot=true>
            <div class="dropzone-custom-content">
                <slot name="content"></slot>
                <div v-if="overlay">
                    <i class="icon icon--close" @click="close" title="Close"> </i>

                    <svg xmlns="http://www.w3.org/2000/svg" width="160" height="159">
                        <g fill="none" fill-rule="evenodd">
                            <g fill="#D9D9D9" fill-rule="nonzero">
                                <path d="M54.4038984,15.4435147 C51.495571,10.2577412 45.7714224,7.28320648 39.6329904,8.26251596 C37.2234718,3.2090326 32.1824192,0 26.5137744,0 C18.4903893,0 11.9623423,6.52172269 11.9623423,14.5392301 C11.9623423,14.8701366 11.975402,15.2111915 12.0051492,15.5663814 C5.08023174,17.14299 0,23.3896216 0,30.5836682 C0,39.0850313 6.92237804,46 15.4315123,46 L27.6289296,46 L27.6289296,43.4538679 L15.4315123,43.4538679 C8.32738643,43.4538679 2.54991066,37.6805812 2.54991066,30.5840306 C2.54991066,24.2319293 7.29639396,18.7609165 13.5933564,17.8606187 C13.9310953,17.8127768 14.2347339,17.6311949 14.4371596,17.3561039 C14.6384969,17.0824627 14.7255618,16.7385083 14.6707835,16.4028901 C14.5630408,15.7128067 14.5086253,15.1046345 14.5086253,14.5403174 C14.5086253,7.9261728 19.896486,2.54576971 26.5141372,2.54576971 C31.4851752,2.54576971 35.8696139,5.5395137 37.688543,10.1714808 C37.9170881,10.758994 38.5414153,11.0899006 39.1606638,10.9470997 C44.7563918,9.65391828 50.0143809,12.3544493 52.4394986,17.169448 C52.6237858,17.5416726 52.984742,17.7986416 53.3975743,17.8569943 C59.6981645,18.7533053 64.4551681,24.2246805 64.4551681,30.5829433 C64.4551681,37.6794938 58.6737019,43.4527805 51.569576,43.4527805 L35.3305377,43.4527805 L35.3305377,45.9989127 L51.5684877,45.9989127 C60.0787103,45.9989127 67,39.083944 67,30.5825809 C67,23.1848438 61.6288267,16.7899746 54.4038984,15.4435147 Z" transform="translate(-375.000000, -317.000000) translate(367.000000, 319.000000) translate(56.000000, 96.000000)"/>
                                <path d="M38.6216661,29.4877831 C39.1261113,28.9790946 39.1261113,28.1564189 38.6216661,27.6477304 L31.4299138,20.3788877 C31.1784088,20.1258125 30.8508423,20 30.5207644,20 L30.4978025,20.0039883 C30.4913444,20.0039883 30.4848864,20 30.4784283,20 C30.1444038,20 29.8146847,20.1308885 29.5692789,20.3788877 L22.3775266,27.648093 C21.8741578,28.1567814 21.8741578,28.9794572 22.3775266,29.4881457 C22.8808955,29.9979218 23.6949681,29.9979218 24.1983369,29.4881457 L29.1893305,24.4440445 L29.1893305,59.6958287 C29.1893305,60.4173469 29.7644554,61 30.4784283,61 C31.1884547,61 31.7664498,60.4173469 31.7664498,59.6958287 L31.7664498,24.398723 L36.8012146,29.4877831 C37.3027895,29.9979218 38.1182973,29.9979218 38.6216661,29.4877831 Z" transform="translate(-375.000000, -317.000000) translate(367.000000, 319.000000) translate(56.000000, 96.000000)"/>
                            </g>
                            <path fill="#FFFFFF" stroke="#D9D9D9" stroke-width="2" d="M18.4564313,0 L43,0 C47.418278,-8.11624501e-16 51,3.581722 51,8 L51,59 C51,63.418278 47.418278,67 43,67 L8,67 C3.581722,67 5.41083001e-16,63.418278 0,59 L0,15.670667 L0,15.670667 L18.4564313,0 Z" transform="translate(-375.000000, -317.000000) translate(367.000000, 319.000000) translate(40.500000, 46.500000) rotate(-33.000000) translate(-40.500000, -46.500000) translate(15.000000, 13.000000)"/>
                            <path fill="#D8D8D8" stroke="#D9D9D9" stroke-width="2" d="M18,0.822392696 L18,8 C18,12.418278 14.418278,16 10,16 L1.40919207,16 L1.40919207,16 L18,0.822392696 Z" transform="translate(-375.000000, -317.000000) translate(367.000000, 319.000000) translate(40.500000, 46.500000) rotate(-33.000000) translate(-40.500000, -46.500000) translate(15.000000, 13.000000)"/>
                            <text fill="#2B92EC" font-family="Poppins-SemiBold, Poppins" font-size="13" font-weight="500" transform="translate(-375.000000, -317.000000) translate(367.000000, 319.000000) translate(40.500000, 46.500000) rotate(-33.000000) translate(-40.500000, -46.500000) translate(15.000000, 13.000000)">
                                <tspan x="13" y="55">.stl</tspan>
                            </text>
                            <path fill="#FFFFFF" stroke="#D9D9D9" stroke-width="2" d="M76.4564313,0 L101,0 C105.418278,-8.11624501e-16 109,3.581722 109,8 L109,59 C109,63.418278 105.418278,67 101,67 L66,67 C61.581722,67 58,63.418278 58,59 L58,15.670667 L58,15.670667 L76.4564313,0 Z" transform="translate(-375.000000, -317.000000) translate(367.000000, 319.000000)"/>
                            <text fill="#5AC556" font-family="Poppins-SemiBold, Poppins" font-size="13" font-weight="500" transform="translate(-375.000000, -317.000000) translate(367.000000, 319.000000)">
                                <tspan x="69.5" y="46">.gco</tspan> <tspan x="72.1455" y="58"> de</tspan>
                            </text>
                            <g>
                                <path fill="#FFFFFF" stroke="#D9D9D9" stroke-width="2" d="M18.4564313,0 L43,0 C47.418278,-8.11624501e-16 51,3.581722 51,8 L51,59 C51,63.418278 47.418278,67 43,67 L8,67 C3.581722,67 5.41083001e-16,63.418278 0,59 L0,15.670667 L0,15.670667 L18.4564313,0 Z" transform="translate(-375.000000, -317.000000) translate(367.000000, 319.000000) translate(129.500000, 44.500000) rotate(33.000000) translate(-129.500000, -44.500000) translate(104.000000, 11.000000)"/>
                                <path fill="#D8D8D8" stroke="#D9D9D9" stroke-width="2" d="M18,0.822392696 L18,8 C18,12.418278 14.418278,16 10,16 L1.40919207,16 L1.40919207,16 L18,0.822392696 Z" transform="translate(-375.000000, -317.000000) translate(367.000000, 319.000000) translate(129.500000, 44.500000) rotate(33.000000) translate(-129.500000, -44.500000) translate(104.000000, 11.000000)"/>
                                <text fill="#FDB139" font-family="Poppins-SemiBold, Poppins" font-size="13" font-weight="500" transform="translate(-375.000000, -317.000000) translate(367.000000, 319.000000) translate(129.500000, 44.500000) rotate(33.000000) translate(-129.500000, -44.500000) translate(104.000000, 11.000000)">
                                    <tspan x="11.6166904" y="54.7059685">.obj</tspan>
                                </text>
                            </g>
                            <path fill="#D8D8D8" stroke="#D9D9D9" stroke-width="2" d="M76.5908079,1 L76.5908079,8.1776073 C76.5908079,12.5958853 73.0090859,16.1776073 68.5908079,16.1776073 L60,16.1776073 L60,16.1776073 L76.5908079,1 Z" transform="translate(-375.000000, -317.000000) translate(367.000000, 319.000000)"/>
                        </g>
                    </svg>
                    <h3 class="dropzone-custom-title">{{$t('apps.upload.dad')}}</h3>
                    <div class="subtitle">{{$t('login.or')}}</div>
                    <b-button variant="-primary btn--outline">{{$t('apps.upload.select')}}</b-button>
                </div>
            </div>
        </vue-dropzone>
        <div class="dropzone-custom-items" v-if="isFiles">
            <files-upload-item v-for="(file, index) in files" :key="index" :file="file"></files-upload-item>
        </div>
    </div>

</template>
<script>
  import {mapActions} from 'vuex'
  import vue2Dropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'
  import FilesUploadItem from './FilesUploadItem'

  const TEMPLATE = `<div></div>`;

  export default {
    name: "FilesUpload",
    props:{
      show:{
        type: Boolean,
        default: false
      },
      overlay:{
        type: Boolean,
        default: true
      },
      projectId: {
        type: String,
        default: null
      },
      clickable: {
        type: Boolean,
        default: true
      }
    },
    components: {
      vueDropzone: vue2Dropzone,
      FilesUploadItem
    },
    created(){


    } ,
    destroyed(){
      //document.body.style.overflow = "auto";
    },
    computed: {
      isProject(){
        return this.projectId !== null ? true : false
      },
      isFiles() {
        return this.files.length > 0 ? true : false
      }
    },
    data: function () {
      return {
        files: [],
        dropzoneOptions: {
          previewTemplate: this.template(),
          //url: 'https://jsonplaceholder.typicode.com/post/',
          url: '/upload/upload',
          thumbnailWidth: 150,
          clickable: this.clickable,
          maxFilesize: null,
          timeout:0,
          headers: {"My-Awesome-Header": "header value"}
        }
      }
    },
    watch: {
      show: function(newVal) { // watch it
        if(newVal){
          document.body.style.overflow = "hidden";
        }else{
          document.body.style.overflow = "auto";
        }
      }
    },
    methods: {
      handleFocusOut(){
        console.log(1)
      },
      ...mapActions(['addUploadFile', 'updateUploadFile', 'highlightFile']),
      addFiles(files){
        this.$refs.myVueDropzone.manuallyAddFile(files[0],'1');
      },
      vSuccess(file, response) {
        //console.log(file, response)
        if (response.result) {
          this.updateUploadFile({
            uploadUiid: file.upload.uuid,
            project_id: response.message.project_id,
            id: response.message.file_id,
            show_select_printers: response.message.show_select_printers
          });
          this.highlightFile(response.message.file_id);
        }
      },

      vDragStart(){
        if (this.$route.name === 'Projects' && !this.isProject) {
          this.$emit('hide')
        }
      },
      vFileAdded() {
        this.$emit('hide')
        // let fileUpload = {
        //     uploadUiid: file.upload.uuid,
        //     uploadProgress: 0,
        //     upload: true,
        //     filename: file.name,
        //     active: "t",
        //     file_type_id: 0,
        //     datetime: '01-01-3003 00:00',
        //     add_datetime: '01-01-3003 00:00',
        //     id: null,
        //     project_id: this.projectId
        //
        // }
        //
        // this.addUploadFile(fileUpload);
        // console.log(file);
        // this.files.push(file.upload)
      },
      close(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        this.$emit('hide')
      },
      _sendFile(file){



        let fileUpload = {
          uploadUiid: file.upload.uuid,
          uploadProgress: 0,
          upload: true,
          filename: file.name,
          active: "t",
          file_type_id: 0,
          datetime: '01-01-3003 00:00',
          add_datetime: '01-01-3003 00:00',
          id: null,
          project_id: this.projectId
        }

        this.addUploadFile(fileUpload);
        if(this.projectId){
          window.eventBus.$emit('project:show', this.projectId);
        }

      } ,
      vSendingFile(file, xhr, formData) {
        if (this.$route.name === 'Projects' && !this.isProject) {
          this.$router.push('/files')
        }
        this._sendFile(file)
        formData.append('printer_type', 1001);
        formData.append('uuid', file.upload.uuid);
        formData.append('newui', 1);

        if(this.projectId) {
          formData.append('project_id', this.projectId);
        }



      },
      vProgress(file, progress) {

        this.updateUploadFile({
          uploadProgress: Math.floor(progress),
          uploadUiid: file.upload.uuid,
        })
        // files, progress
        // let file =  this.findFileItem(files.upload.uuid)
        // file .progress = Math.floor(progress)
      },
      findFileItem(uuid) {
        return this.files.find(files => files.uuid == uuid);
      },
      template: function () {
        return TEMPLATE
      },
      thumbnail: function (file, dataUrl) {
        console.log(file, dataUrl)
        var j, len, ref, thumbnailElement;
        if (file.previewElement) {
          file.previewElement.classList.remove("dz-file-preview");
          ref = file.previewElement.querySelectorAll("[data-dz-thumbnail-bg]");
          for (j = 0, len = ref.length; j < len; j++) {
            thumbnailElement = ref[j];
            thumbnailElement.alt = file.name;
            thumbnailElement.style.backgroundImage = 'url("' + dataUrl + '")';
          }
          return setTimeout(() => {
            return () => {
              return file.previewElement.classList.add("dz-image-preview");
            };
          }, 1);
        }
      }
    }
  }
</script>

<style lang="scss">
    /*#dropzone{*/
    /*position: fixed;*/
    /*z-index: 9;*/
    /*width: 100%;*/
    /*height: calc(100vh - 182px);*/
    /*background-color: #ffffffd9;*/
    /*}*/
    @import "../../../scss/theme";

    .customdropzone {

        .dropzone-custom-content {
            border-radius: $s-border-radius;
            //margin-top: -10px;
            margin-top: -23%;
        }

        .icon--close{
            position: absolute;
            top: 0;
            right: 15px;
            &:before, &:after{
                background: #636363;
            }
        }


        &.table--files-wrapper{
            .vue-dropzone{
                border: 0 !important;

                font-family: inherit !important;
                letter-spacing: .2px;
                color: inherit !important;
                -webkit-transition: .2s linear;
                transition: .2s linear;

            }
            .dropzone-custom-content{
                margin-top: auto;
            }
            #customdropzone{
                border-radius: 8px;
                padding: 0 !important;
                min-height: auto !important;
                .dz-message{
                    margin: 0 !important;
                    text-align: left !important;
                }
            }
        }
        position: relative;
        &.hide{
            // display: none;
        }


        &__area {

            position: absolute;
            z-index: 100;
            width: 100%;
            height: 90vh;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(255, 255, 255, .91);
            border-radius: $s-border-radius;
            border: 1px dashed $c-border;
            padding: 40px;
            color: #636363;
            font-family: $f-primary;
            transition: .2s;


            &:hover, &.dz-drag-hover{
                transition: .1s;
                background: rgba(255, 255, 255, .97);
                border: 1px dashed $c-primary;
                color: $c-primary;

                .dz-message {
                    opacity: 1;
                }
            }

            &.dz-drag-hover {
                .dz-message {
                    animation: blink 750ms infinite;
                }
            }

            h3 {
                margin-top: 36px;
                margin-bottom: 24px;
                font-weight: 400;
            }
            .btn {
                margin-top: 24px;
            }
        }
    }

    #customdropzone .dz-preview {
        width: 160px;
        display: inline-block
    }

    #customdropzone .dz-preview .dz-image {
        width: 80px;
        height: 80px;
        margin-left: 40px;
        margin-bottom: 10px;
    }

    #customdropzone .dz-preview .dz-image > div {
        width: inherit;
        height: inherit;
        border-radius: 50%;
        background-size: contain;
    }

    #customdropzone .dz-preview .dz-image > img {
        width: 100%;
    }

    #customdropzone .dz-preview .dz-details {
        color: black;
        text-align: center;
    }

    #customdropzone .dz-success-mark, .dz-error-mark, .dz-remove {
        display: none;
    }

    #customdropzone .dz-message {
        display: block !important;
    }

</style>
